import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/law/')({
  // Redirect in beforeLoad (not via a rendered <Navigate>) so this hop chains with the vault
  // index guard and resolves before the location commits — the address bar jumps straight to the
  // final scoped URL instead of visibly stepping /law → /law/vault → /law/vault?clientId=…
  beforeLoad: () => {
    throw redirect({ to: '/law/vault', search: true, replace: true })
  },
})
